<template>
  <div class="x-tablelist-view" data-automation="shortMessage">
    <!-- 搜索行 -->
    <ux-searchOption
      :layout="layout"
      :data="filter"
      @search="seach"
      @input="seach"
      @add="showAdd"
    ></ux-searchOption>
    <!-- 表格 -->
    <div class="x-table-box">
      <ux-table
        ref="table"
        maxHeight="100%"
        :hide-on-single-page="true"
        :data="tableData.list"
        :columns="columns"
        :total="tableData.totalSize"
        :size.sync="filter.size"
        :page.sync="filter.page"
        @changePage="changePage"
        :emptyText="$t('HT.nodata')"
        @changeSize="changeSize"
        layout="total, sizes, prev, pager, next"
      ></ux-table>
    </div>
  </div>
</template>
<script>
import addSms from './template/addSms';
export default {
  components: {
    addSms
  },
  data() {
    return {
      layout: [
        // 搜索项配置
        {
          type: 'input',
          key: 'name',
          placeholder: '请输入搜索内容'
        },
        {
          type: 'button',
          text: '添加签名',
          right: true,
          hidden: !this.$hasModule(40),
          event: 'add'
        }
      ],
      columns: [
        // 表头数据
        {
          label: '签名名称',
          prop: 'name',
          tooltip: true,
          formatter: (row, column, cellValue) => {
            let value = `【${cellValue}】`;
            return value;
          }
        },
        {
          label: '创建时间',
          prop: 'created_date',
          tooltip: true
        },
        {
          label: '审核状态',
          prop: 'status',
          tooltip: true,
          formatter: (row, column, cellValue) => {
            return this.$opt.switchStr(cellValue, this.$opt.SmsStatus);
          }
        },
        {
          label: '操作',
          hidden: !this.$hasModule(40),
          render: (h, params) => {
            return h('my-table-btn', {
              props: {
                data: ['修改', '删除'],
                className: ['', params.status === 1 ? 'no-click' : ''],
                colors: ['#0087ff'],
                event: ['modify', 'del']
              },
              on: {
                modify: () => {
                  this.$uxModal.show({
                    title: '修改签名',
                    content: (h) => {
                      return h(addSms, {
                        props: {
                          data: params
                        }
                      });
                    },
                    confirm: (data) => {
                      this.modifyList(params.id, data);
                    }
                  });
                },
                del: () => {
                  this.$uxModal.show({
                    title: '删除签名',
                    content: '确定要删除该签名吗？',
                    confirm: () => {
                      this.delList(params.id);
                    }
                  });
                }
              }
            });
          }
        }
      ],
      filter: {
        // 查询参数
        name: '', // 短信签名
        status: '', //审批状态
        page: 1,
        size: 10
      },
      tableData: {
        // 表格数据
        totalSize: 0,
        list: []
      }
    };
  },
  created() {
    this.getList(this.filter);
  },
  methods: {
    /**
     * 获取列表
     * @param {Object} params 请求参数
     */
    getList(params) {
      this.$uxLoading.show();
      this.$api.message.getSign(params).then((res) => {
        if (res.code == 10000) {
          this.tableData = {
            totalSize: res.total_size,
            list: res.data
          };
        }
      });
    },

    /**
     * 添加列表
     * @param {Object} params 表单提交参数
     */
    addSms(params) {
      this.$uxLoading.show();
      this.$api.message.addSign(params).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          this.$uxMessage.success('添加成功');
          this.getList(this.filter);
        }
      });
    },

    /**
     * 删除列表
     * @param {String} id 唯一标识
     */
    delList(id) {
      this.$uxLoading.show();
      this.$api.message.delSign(id).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          this.$uxMessage.success('删除成功');
          this.getList(this.filter);
        }
      });
    },

    /**
     * 修改列表
     * @param {Object} params 表单提交参数
     */
    modifyList(id, params) {
      this.$uxLoading.show();
      this.$api.message.changeSign(id, params).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          this.$uxMessage.success('修改成功');
          this.getList(this.filter);
        }
      });
    },

    /**
     * 新建分组弹窗
     */
    showAdd() {
      this.$uxModal.show({
        title: '添加签名',
        content: (h) => {
          return h(addSms);
        },
        confirm: (params) => {
          this.addSms(params);
        }
      });
    },

    /**
     * 点击搜索
     */
    seach() {
      this.filter.page = 1;
      this.getList(this.filter);
    },
    /**
     * 改变页容量
     * @param {Number} size 选择的页容量
     */
    changeSize(size) {
      this.filter.size = size;
      this.filter.page = 1;
      this.getList(this.filter);
    },
    /**
     * 改变页码
     * @param {Number} page 选择的页码
     */
    changePage(page) {
      this.filter.page = page;
      this.getList(this.filter);
    }
  }
};
</script>
